import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {
  BlurWrapperComponent,
  GridModule,
  IconButtonComponent,
  NotificationsModule,
  PrimaryButtonComponent
} from '@q9elements/ui-kit/components';

import {OrgNodeSidebarModule} from '@q9elements/ui-kit/refmodels';
import {InternalSidebarModule} from '../internal-sidebar/internal-sidebar.module';
import {SharedModule} from '../shared/shared.module';
import {SidebarHeaderModule} from '../sidebar/components/sidebar-header/sidebar-header.module';
import {SidebarWrapperModule} from '../sidebar/sidebar-wrapper.module';
import {ImpactGridViewComponent} from './impact-grid-view.component';
import {ImpactGridViewDaoService} from './services/impact-grid-view-dao.service';
import {ImpactGridQuery} from './state/impact-grid.query';
import {ImpactGridStore} from './state/impact-grid.store';

@NgModule({
  declarations: [ImpactGridViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    GridModule.withStore(ImpactGridStore, ImpactGridQuery),
    NotificationsModule,
    SidebarWrapperModule,
    TranslateModule,
    GridModule,
    IconButtonComponent,
    OrgNodeSidebarModule,
    SidebarHeaderModule,
    InternalSidebarModule,
    PrimaryButtonComponent,
    BlurWrapperComponent
  ],
  providers: [ImpactGridViewDaoService, ImpactGridStore, ImpactGridQuery]
})
export class ImpactGridViewModule {}
